var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comparison"},[_c('Card',{attrs:{"label":_vm.$t('components.tenant.sc_journey.provided_by_subject'),"data":_vm.data.candidate,"compareData":_vm.data.referee,"showMark":true}}),_c('Card',{attrs:{"label":_vm.$t('components.tenant.sc_journey.provided_by_referee'),"data":_vm.data.referee,"compareData":_vm.data.candidate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }